import type { Entities, AccessType } from '../../types';
import {
	FETCH_PROJECT_ACCESS_TYPES,
	FETCH_PROJECT_ACCESS_TYPES_SUCCESS,
	FETCH_PROJECT_ACCESS_TYPES_FAIL,
	SET_PROJECT_ACCESS_TYPE,
} from './project-access-type';

export const fetchProjectAccessTypes = () => ({
	type: FETCH_PROJECT_ACCESS_TYPES,
});

export type FetchProjectAccessTypes = ReturnType<typeof fetchProjectAccessTypes>;

export const fetchProjectAccessTypesSuccess = (ProjectAccessTypes: Entities) => ({
	type: FETCH_PROJECT_ACCESS_TYPES_SUCCESS,
	payload: ProjectAccessTypes,
});

export type FetchProjectAccessTypesSuccess = ReturnType<typeof fetchProjectAccessTypesSuccess>;

export const fetchProjectAccessTypesFail = (message: string) => ({
	type: FETCH_PROJECT_ACCESS_TYPES_FAIL,
	payload: { message },
});

export type FetchProjectAccessTypesFail = ReturnType<typeof fetchProjectAccessTypesFail>;

export const setProjectAccessType = (accessType?: AccessType | null) => ({
	type: SET_PROJECT_ACCESS_TYPE,
	payload: {
		accessType,
	},
});

export type SetProjectAccessType = ReturnType<typeof setProjectAccessType>;

export type Action =
	| FetchProjectAccessTypes
	| FetchProjectAccessTypesSuccess
	| FetchProjectAccessTypesFail
	| SetProjectAccessType;
